export function getTooltipText(hasNote) {
	return hasNote ? $.__('Update Project or Note') : $.__('Add Project or Note');
}
